module.exports = __webpack_public_path__ + "static/media/card4_0@2x.6174f282.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/card4_0@2x.png
// module id = 1714
// module chunks = 0